import { onMount } from "svelte";

/**
 *
 *
 *
 *
 *
 *
 */
export const useDialogPopoverInterceptor = (
  self: () => HTMLElement | undefined,
  cb: () => void,
): void => {
  onMount(() => {
    const origShowPopover = HTMLElement.prototype.showPopover;
    HTMLElement.prototype.showPopover = function () {
      origShowPopover.apply(this);
      if (self() !== this) cb();
    };

    /*                                                                                                 */
    const methods = ["show", "showModal", "showPopover"] as const;
    const restoreDialogShowMethods = methods.map((method) => {
      /*                              */
      const originalMethod = HTMLDialogElement.prototype[method];
      HTMLDialogElement.prototype[method] = function () {
        originalMethod.apply(this);
        cb();
      };
      return () => (HTMLDialogElement.prototype[method] = originalMethod);
      /*                             */
    });

    return () => {
      HTMLElement.prototype.showPopover = origShowPopover;
      restoreDialogShowMethods.forEach((restore) => restore());
    };
  });
};
